import { DragDropModule } from '@angular/cdk/drag-drop';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { CepService, ViggoCoreComponentsModule } from 'viggo-sistemas-core-web';
import { FastCadastroModule } from '../modules/fast-cadastro/fast-cadastro.module';
import { ProdutoService } from '../modules/produto/services/produto-service/produto.service';
import {
  AddRemoveControlesComponent,
  BreadcrumbComponent,
  CardInserirDadosEmpresaComponent,
  CardPerfilEmpresaComponent,
  CarouselComponent,
  ChipInputComponent,
  DialogSearchComponent,
  DialogTutorialInfoComponent,
  SliderHorizontalComponent,
  TutorialPrimeirosPassosComponent
} from './components';
import { AppAutocompleteComponent } from './components/app-autocomplete/app-autocomplete.component';
import { AppInputComponent } from './components/app-input/app-input.component';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { ChipsAutocomplete } from './components/chip-autocomplete/chip-autocomplete.component';
import { ColorPaletteComponent } from './components/color-palette/color-palette.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { ColorSliderComponent } from './components/color-slider/color-slider.component';
import { DialogConfirmComponent } from './components/confirm-delete.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DialogMsgSubMsgComponent } from './components/dialog-msgs-submsgs/dialog-msgs-submsgs.component';
import { ControlsActionComponent } from './components/search-header/components/controls-action/controls-action.component';
import { ControlsViewTypeComponent } from './components/search-header/components/controls-view-type/controls-view-type.component';
import { ViggoCoreSearchHeaderComponent } from './components/search-header/components/search-header/search-header.component';
import { TableComponent } from './components/table/table.component';
import { DateMaskDirective } from './directives/datepickermask.directive';
import { FormatDataDirective } from './directives/format-data.directive';
import { HeaderFormatDirective } from './directives/header-format.directive';
import { CapitalizePipe, CepPipe, CpfCnpjPipe, SafePipe } from './pipes';
import { TypeOfPipe } from './pipes/typeof/typeof.pipe';
@NgModule({
  declarations: [
    CepPipe,
    SafePipe,
    CapitalizePipe,
    CpfCnpjPipe,
    TypeOfPipe,
    FormatDataDirective,
    DateMaskDirective,
    CarouselComponent,
    ChipInputComponent,
    DialogMsgSubMsgComponent,
    DialogConfirmComponent,
    DialogTutorialInfoComponent,
    TutorialPrimeirosPassosComponent,
    CardInserirDadosEmpresaComponent,
    CardPerfilEmpresaComponent,
    SliderHorizontalComponent,
    BreadcrumbComponent,
    AddRemoveControlesComponent,
    HeaderFormatDirective,
    CardHeaderComponent,
    AppAutocompleteComponent,
    TableComponent,
    AppInputComponent,
    ViggoCoreSearchHeaderComponent,
    ControlsViewTypeComponent,
    ControlsActionComponent,
    ConfirmDialogComponent,
    DialogSearchComponent,
    ColorPaletteComponent,
    ColorPickerComponent,
    ColorSliderComponent,
    ChipsAutocomplete,
  ],
  imports: [
    CommonModule,
    ViggoCoreComponentsModule,
    FastCadastroModule,
    ReactiveFormsModule,
    NgxMaskModule.forChild(),
    RouterModule,
    FormsModule,
    // mat modules
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatListModule,
    MatProgressBarModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    DragDropModule,
    MatTreeModule,
    // primeng modules
    InputTextModule,
    InputTextareaModule,
    ChipsModule,
    RippleModule,
    ButtonModule,
    StyleClassModule,
    DropdownModule,
    ProgressBarModule,
    MenuModule,
    CalendarModule,
    InputMaskModule,
    ChipsModule,
    PaginatorModule,
    TableModule,
    CheckboxModule
  ],
  exports: [
    CepPipe,
    SafePipe,
    CpfCnpjPipe,
    CapitalizePipe,
    TypeOfPipe,
    CarouselComponent,
    ChipInputComponent,
    BreadcrumbComponent,
    DialogConfirmComponent,
    SliderHorizontalComponent,
    CardPerfilEmpresaComponent,
    AddRemoveControlesComponent,
    CardInserirDadosEmpresaComponent,
    TutorialPrimeirosPassosComponent,
    FormatDataDirective,
    HeaderFormatDirective,
    DateMaskDirective,
    CardHeaderComponent,
    AppAutocompleteComponent,
    TableComponent,
    AppInputComponent,
    ViggoCoreSearchHeaderComponent,
    ControlsViewTypeComponent,
    ControlsActionComponent,
    ConfirmDialogComponent,
    ColorPaletteComponent,
    ColorPickerComponent,
    ColorSliderComponent,
    ChipsAutocomplete,
    ConfirmDialogComponent
  ],
  // define os providers para serem globais dentro da aplicação
  providers: [
    CepService,
    ProdutoService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false, showError: true }
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class SharedModule {}
